module.exports = __webpack_public_path__ + "static/media/insta@2x.f1d539e3.png";